import { applyMiddleware, combineReducers, legacy_createStore as createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import thunk from 'redux-thunk';

// defaults to localstorage on web, AsyncStorage on react-native
import { storage } from 'core';

// import reducers
import admin from './reducers/admin';
import appState from './reducers/appState';
import browse from './reducers/browse';
import chats from './reducers/chats';
import connects from './reducers/connects';
import home from './reducers/home';
import liveStream from './reducers/liveStream';
import news from './reducers/news';
import notifications from './reducers/notifications';
import paymentHistory from './reducers/paymentHistory';
import posts from './reducers/posts';
import shoutout from './reducers/shoutout';
import shoutouts from './reducers/shoutouts';
import shop from './reducers/store';
import streaming from './reducers/streaming';
import subscriptions from './reducers/subscriptions';
import user from './reducers/user';
// import comingSoon from './reducers/comingSoon'
import engagement from './reducers/engagement';
import letsChatSports from './reducers/letsChatSports';
import globalModalsState from './reducers/modals';
import requestShoutout from './reducers/requestShoutout';
import shoutoutRequest from './reducers/shoutoutRequest';
import shoutoutsAthlete from './reducers/shoutoutsAthlete';
import viewsOnTheNews from './reducers/viewsOnTheNews';

const rootPersistConfig = {
  key: 'root',
  storage: storage,
  stateReconciler: hardSet,
  timeout: null,
  blacklist: [
    'streaming',
    'shoutout',
    'admin',
    'requestShoutout',
    'shoutoutsAthlete',
    'shoutoutRequest',
    'letsChatSports',
    'viewsOnTheNews',
    'globalModalsState',
    'engagement'
  ]
};

const rootReducer = combineReducers({
  streaming,
  user,
  appState,
  home,
  notifications,
  chats,
  connects,
  shoutout,
  posts,
  shoutouts,
  news,
  paymentHistory,
  browse,
  admin,
  liveStream,
  subscriptions,
  store: shop,
  // comingSoon,
  requestShoutout,
  shoutoutsAthlete,
  shoutoutRequest,
  letsChatSports,
  viewsOnTheNews,
  globalModalsState,
  engagement
});

const pReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = createStore(pReducer, applyMiddleware(thunk));
export const persistor = persistStore(store);
